import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatBytes } from 'utils/helpers/formatters';
import TooltipWrapper from 'components/TooltipWrapper';
import { FaTrash } from 'react-icons/fa';
import styled from 'styled-components';
import Button from 'components/Button';

interface IAttachment {
  id: number;
  file_name: string;
  size: number;
}

interface IProps {
  items: IAttachment[];
  onDelete: (id: number) => void;
}

const Attachments: FC<IProps> = ({ items, onDelete }: IProps) => {
  const { t } = useTranslation();
  return (
    <>
      <h4 className="text-center mb-4">{t('common.currentlyUploadedFiles')}</h4>
      <ul>
        {items.map((file: IAttachment) => (
          <li>
            <FlexWrapper className="mb-2">
              <div>
                <span className="d-inline-block font-weight-bold">{file.file_name}</span>
                <span className="d-inline-block">&nbsp;-&nbsp;</span>
                <span className="d-inline-block">{formatBytes(file.size)}</span>
              </div>
              <div className="d-inline-block">
                <TooltipWrapper
                  id="tooltip-trash"
                  overlay="Изтрий"
                >
                  <Button
                    btnType="danger"
                    size="sm"
                    outlined
                    onClick={() => onDelete(file.id)}
                  >
                    <FaTrash size={14} />
                  </Button>
                </TooltipWrapper>
              </div>
            </FlexWrapper>
          </li>
        ))}
      </ul>
    </>
  );
};

const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default Attachments;
